import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { CookieBanner } from "../modules/CookieBanner/CookieBanner";
import { Header } from "../modules/Header/Header";
import { Footer } from "../modules/Footer/Footer";

export const LayoutPage = ({
  cookieConsent,
  isCookieBannerOpen,
  language,
  onCookieConsentChange,
  onLanguageChange,
  onOpenCookieSettings,
  t,
}) => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const targetId = location.hash.slice(1);

    const scrollToTarget = () => {
      const element = document.getElementById(targetId);

      if (!element) {
        return false;
      }

      element.scrollIntoView({ behavior: "smooth", block: "start" });

      return true;
    };

    if (scrollToTarget()) {
      return;
    }

    const timeoutId = setTimeout(scrollToTarget, 100);

    return () => clearTimeout(timeoutId);
  }, [location.hash, location.pathname]);

  return (
    <>
      <Header
        language={language}
        onLanguageChange={onLanguageChange}
        t={t}
      />
      <main>
        <Outlet />
      </main>
      <Footer onOpenCookieSettings={onOpenCookieSettings} t={t} />
      {isCookieBannerOpen ? (
        <CookieBanner
          onAccept={() => onCookieConsentChange("accepted")}
          onReject={() => onCookieConsentChange("rejected")}
          t={t}
        />
      ) : null}
    </>
  );
};
